import React from 'react';
import s from './index.module.scss';

import checkTheme from '../../../../../src/utils/custom/checkTheme';
import visa from './img/visa.svg';
import visa_dark from './img/visa_dark.png';
import mastercard from './img/mastercard.svg';
import americanExpress from './img/american-express.svg';
import discover from './img/discover.png';
import discover_dark from './img/discover_dark.png';
import jcb from './img/jcb.svg';
import local from './img/local.svg';
import local_dark from './img/local_dark.png';
import localDark from './img/local-dark.svg';
import stripe from './img/stripe.png';
import stripe_dark from './img/stripe_dark.png';
import stripeDark from './img/stripe-dark.png';
import paypal from './img/paypal.svg';
import paypal_dark from './img/paypal_dark.png';
import { useT } from '@hooks';
import { appStore } from '@store';

function SafeCheckout() {
	const { T } = useT();
	const gender = appStore.params.gender;
	const isDark = gender === 'male';

	return (
		<div className={`${s.safeCheckout} ${s[checkTheme()]}`}>
			<h2 className={s.safeCheckout_Title}>{T('guaranteed')}</h2>
			{checkTheme() === 'darkMode' ? (
				<div className={s.safeCheckout_Images}>
					<img className={s.safeCheckout_Img} src={visa_dark} alt='Visa' width='41' />
					<img className={s.safeCheckout_Img} src={mastercard} alt='Mastercard' width='29' />
					<img className={s.safeCheckout_Img} src={americanExpress} alt='American Express' width='34' />
					<img className={s.safeCheckout_Img} src={paypal_dark} alt='Paypal' width='63'/>
					<img className={s.safeCheckout_Img} src={discover_dark} alt='Discover' width='53' />
					<img className={s.safeCheckout_Img} src={jcb} alt='JCB' width='27' />
					<img className={s.safeCheckout_Img} src={local_dark} alt='Local' width='28' />
					<img className={s.safeCheckout_Img} src={stripe_dark} alt='stripe' width='48' />
				</div>
			) : (
				<div className={s.safeCheckout_Images}>
					<img className={s.safeCheckout_Img} src={visa} alt='Visa' />
					<img className={s.safeCheckout_Img} src={mastercard} alt='Mastercard' />
					<img className={s.safeCheckout_Img} src={americanExpress} alt='American Express' />
					<img className={s.safeCheckout_Img} src={paypal} alt='Paypal' />
					<img className={s.safeCheckout_Img} src={discover} alt='Discover' width='53' />
					<img className={s.safeCheckout_Img} src={jcb} alt='JCB' />
					<img className={s.safeCheckout_Img} src={isDark ? localDark : local} alt='Local' />
					<img
						className={s.safeCheckout_Img}
						src={isDark ? stripeDark : stripe}
						alt='stripe'
						width='51'
					/>
				</div>
			)}
		</div>
	);
}

export default SafeCheckout;
